<script setup></script>

<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_8033_2692)">
      <path
        d="M12.0429 18.5212V17.1548C12.0429 16.43 11.755 15.7348 11.2424 15.2223C10.7299 14.7098 10.0348 14.4219 9.30999 14.4219H3.84422C3.11941 14.4219 2.42429 14.7098 1.91177 15.2223C1.39926 15.7348 1.11133 16.43 1.11133 17.1548V18.5212M16.1422 18.5212V17.1548C16.1418 16.5492 15.9402 15.961 15.5692 15.4824C15.1983 15.0039 14.6788 14.6621 14.0925 14.5107M11.3597 6.31202C11.9475 6.46254 12.4686 6.80442 12.8406 7.28378C13.2127 7.76313 13.4147 8.35269 13.4147 8.95951C13.4147 9.56633 13.2127 10.1559 12.8406 10.6352C12.4686 11.1146 11.9475 11.4565 11.3597 11.607M9.30999 8.95609C9.30999 10.4654 8.08644 11.689 6.5771 11.689C5.06777 11.689 3.84422 10.4654 3.84422 8.95609C3.84422 7.44676 5.06777 6.22321 6.5771 6.22321C8.08644 6.22321 9.30999 7.44676 9.30999 8.95609Z"
        stroke="currentColor"
        stroke-width="1.71429"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.1797 7.55896V13.4595"
        stroke="currentColor"
        stroke-width="1.71429"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M23.13 10.5093H17.2295"
        stroke="currentColor"
        stroke-width="1.71429"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>
